export function formatFileSize(bytes: number) {
  if (bytes === 0) return '0B'
  const k = 1024
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  const size = bytes / Math.pow(k, i)
  return `${size.toFixed(size < 10 && i > 0 ? 1 : 0)}${['B', 'kB', 'MB', 'GB', 'TB', 'PB'][i]}`
}
